
import { Vue } from "vue-class-component";
import moment from "moment";
import {getInterventionsLogsRequest} from "@/services/InterventionService";

export default class Interventions extends Vue {
	headline = "Interventionen Logs"
	logs: any = []
	moment = moment
	
	getLogs() {
		getInterventionsLogsRequest().then((res: any) => {
			if ( res.status == "OK" && res.result.length > 0 ) {
				this.logs = res.result
			}
		})
	}
	
	beforeMount() {
		this.getLogs()
	}
}
